import { render } from "./red_hand.vue?vue&type=template&id=69c3e06e"
import script from "./red_hand.vue?vue&type=script&lang=js"
export * from "./red_hand.vue?vue&type=script&lang=js"

import exportComponent from "/root/qzf/src/invoice-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__